import React, { useMemo, useState, useEffect } from 'react';
import get from 'lodash/get';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { getUserStatus } from '../../../helpers/utils';
import MenuItem from '../../atoms/menu-item';
import SubMenuBar from '../../molecules/sub-menu-bar';
import Premium from '../../atoms/logo/premium';
import './main-menu.m.css';

const MainMenu = React.memo(({ showMenuBar, menus }) => {
  const mainMenuList = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'main_menu_list'], []),
  );
  const userData = useSelector((state) => get(state, ['userData']));
  const worldsummit = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'worldsummit'], {}),
  );
  const [menuSource, setMenuSource] = useState(mainMenuList);
  useEffect(() => {
    if (menus && menus?.length > 0) {
      setMenuSource(menus);
    }
  }, [menus]);
  // Render home item or skeleton
  const renderHomeItem = () => {
    const handleHomeItemClick = () => {
      const baseData = {
        event: 'navigation_interaction',
        cta_text: 'home',
        select_type: 'header',
        page_template: pageType,
        user_id: userData?.userProfile?.userId || 'NA',
        user_status: getUserStatus(),
        login_type: userData?.isLoggedIn ? 'logged-in' : 'logged-out',
        language_hit: 'english',
        Platform: isMobile ? 'mobile' : 'desktop',
        SiteName: 'www.ndtvprofit.com',
      };

      if (typeof window !== 'undefined' && window.dataLayer) {
        const pageviewEvent = window.dataLayer.find((item) => item.event === 'pageview');
        if (pageviewEvent) {
          baseData.page_template = pageviewEvent.page_template;
        } else {
          console.log('pageviewEvent event not found in dataLayer');
        }
        window.dataLayer.push(baseData);
      } else {
        console.error('Error: window.dataLayer is not available');
      }
    };
    return (
      <a
        styleName={`home-item ${showMenuBar ? 'mb-home-item' : ''}`}
        href="/?src=top_nav"
        onClick={handleHomeItemClick}
        aria-label="home"
        title="Business News"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 22.775 19.359">
          <path
            fill="var(--regent-gray)"
            d="M11.11,22.359V15.526h4.555v6.833h5.694v-9.11h3.416L13.388,3,2,13.249H5.416v9.11Z"
            transform="translate(-2 -3)"
          />
        </svg>
      </a>
    );
  };

  return (
    <div styleName={`main-menu ${showMenuBar ? 'left-align' : ''}`}>
      {menuSource.length > 0 && renderHomeItem()}
      {menuSource.map((item, index) => (
        <React.Fragment key={index}>
          <MenuItem
            hideIcon={!(item.children && item.children.length)}
            href={
              `${item.title === worldsummit.name ? `${worldsummit?.link}?${worldsummit?.utm}` : `${item.completeUrl}?src=topnav`}` ||
              '/'
            }
            target={item.title === worldsummit.name ? '_blank' : '_self'}
            style={{ fontWeight: 500, color: item?.data?.color || '#2b2b2b' }}
            onClick={() => {
              const baseData = {
                event: 'navigation_interaction',
                cta_text: item?.title || 'NA',
                select_type: 'header',
                page_template: pageType || 'NA',
                user_id: userData?.userProfile?.userId || 'NA',
                user_status: getUserStatus(),
                login_type: userData?.isLoggedIn ? 'logged-in' : 'logged-out',
                language_hit: 'english',
                Platform: isMobile ? 'mobile' : 'desktop',
                SiteName: 'www.ndtvprofit.com',
              };

              if (typeof window !== 'undefined' && window.dataLayer) {
                const pageviewEvent = window.dataLayer.find((item) => item.event === 'pageview');
                if (pageviewEvent) {
                  baseData.page_template = pageviewEvent.page_template;
                } else {
                  console.log('pageviewEvent event not found in dataLayer');
                }
                window.dataLayer.push(baseData);
              } else {
                console.error('Error: window.dataLayer is not available');
              }
            }}
          >
            {item.completeUrl === '/premium' ? (
              <Premium fontSize="16px" />
            ) : item.completeUrl === '/budget' ? (
              <div styleName="budget-text">BUDGET</div>
            ) : item.title.toLowerCase() === 'beeps' ? (
              <div styleName="beeps-text">{item.title}</div>
            ) : item.title === worldsummit.name ? (
              <img
                src={worldsummit?.desk_img}
                height={worldsummit?.mb_height}
                width={worldsummit?.width}
                alt={worldsummit?.name}
                styleName="world-img"
              />
            ) : (
              item.title
            )}
          </MenuItem>
          {item.children && item.children.length ? <SubMenuBar subMenu={item.children} /> : null}
        </React.Fragment>
      ))}
    </div>
  );
});

export default MainMenu;
